/**
 * DOM 操作工具函数
 * @description 提供常用的 DOM 操作方法
 */

/**
 * 监听窗口 resize 事件
 * @param {Window} window - 窗口对象
 * @param {Function} func - 回调函数
 * @returns {Function} 取消监听函数
 */
export function windowsRise(window, func) {
    // 使用防抖优化性能
    let timer = null;
    
    const resizeHandler = () => {
        // 清除之前的定时器
        if (timer) {
            clearTimeout(timer);
        }
        
        // 设置新的定时器，300ms 防抖
        timer = setTimeout(() => {
            if (typeof func === 'function') {
                func();
            }
        }, 300);
    };
    
    // 添加事件监听
    window.addEventListener('resize', resizeHandler);
    
    // 返回取消监听函数，便于组件销毁时调用
    return () => {
        window.removeEventListener('resize', resizeHandler);
        if (timer) {
            clearTimeout(timer);
        }
    };
}

/**
 * 防抖函数
 * @param {Function} func - 要防抖的函数
 * @param {Number} wait - 等待时间（毫秒）
 * @returns {Function}
 */
export function debounce(func, wait = 300) {
    let timer = null;
    
    return function(...args) {
        if (timer) {
            clearTimeout(timer);
        }
        
        timer = setTimeout(() => {
            func.apply(this, args);
        }, wait);
    };
}

/**
 * 节流函数
 * @param {Function} func - 要节流的函数
 * @param {Number} wait - 间隔时间（毫秒）
 * @returns {Function}
 */
export function throttle(func, wait = 300) {
    let timer = null;
    let lastTime = 0;
    
    return function(...args) {
        const now = Date.now();
        
        if (now - lastTime >= wait) {
            if (timer) {
                clearTimeout(timer);
            }
            func.apply(this, args);
            lastTime = now;
        } else {
            if (timer) {
                clearTimeout(timer);
            }
            timer = setTimeout(() => {
                func.apply(this, args);
                lastTime = Date.now();
            }, wait - (now - lastTime));
        }
    };
}
